/* eslint-disable import/no-dynamic-require */
/* eslint-disable global-require */
import React from 'react';
import styled from 'styled-components';
import { Row, Col, ContainerFluid } from '../grid';
import { Title } from '../title';
import { makePageTitle, makeErrorWrapper, makeErrorImage, makeElementsContainer, makeSubtitle } from './mixins';
const PageTitle = styled(Title) `
  ${props => makePageTitle(props)}
`;
const ErrorWrapper = styled.div `
  ${() => makeErrorWrapper()}
`;
const ErrorImage = styled.img `
  ${props => makeErrorImage(props)}
`;
const ElementsContainer = styled.div `
  ${props => makeElementsContainer(props)}
`;
const ErrorStatusContainer = styled.div ``;
const Subtitle = styled.p `
  ${props => makeSubtitle(props)}
`;
const ErrorPage = ({ statusCode = '404', setting }) => {
    const pageSetting = setting();
    return (React.createElement(ErrorWrapper, null,
        React.createElement("meta", { name: "prerender-status-code", content: statusCode }),
        React.createElement(ContainerFluid, null,
            React.createElement(Row, null,
                React.createElement(Col, { sm: 12, noGutter: true }, statusCode && (React.createElement(ElementsContainer, null,
                    pageSetting[statusCode].alt && pageSetting[statusCode].img && (React.createElement(ErrorImage, { alt: pageSetting[statusCode].alt, src: require(`../../assets/img/error-pages/${pageSetting[statusCode].img}`) })),
                    React.createElement(ErrorStatusContainer, null,
                        React.createElement(PageTitle, { level: 1 }, pageSetting[statusCode].title),
                        pageSetting[statusCode].subtitle && React.createElement(Subtitle, null, pageSetting[statusCode].subtitle)))))))));
};
export default ErrorPage;
